class ContactsImportService {
  processGmailCSV (results) {
    results = results.data.filter((result) => {
      return Object.values(result).filter(value => !!value).length !== 0
    }).map((result) => ({
      firstname: result['Given Name'],
      lastname: result['Family Name'],
      phones: [result['Phone 1 - Value']]
    }))
    return results
  }
}

export default new ContactsImportService()
